import type React from 'react';

import { Item, List } from './wrapper';

interface IBulletSeparatedList {
  items: React.ReactNode[];
  tone?: 'alt';
  size?: 'xsmall' | 'small';
}

const BulletSeparatedList = ({ items, tone, size }: IBulletSeparatedList) => (
  <List $tone={tone} $size={size}>
    {items?.map((item, i) => (item ? <Item key={`${item}-${i}`}>{item}</Item> : null))}
  </List>
);

export default BulletSeparatedList;
